import { pgTable, serial, text, integer, timestamp, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const reportsTable = pgTable("reports", {
  id: serial("id").primaryKey(),
  companyId: integer("company_id").notNull(),
  userId: integer("user_id"),
  tenderId: integer("tender_id"),
  title: text("title").notNull(),
  type: text("type", { enum: ["analysis", "compliance", "proposal", "summary"] }).notNull().default("analysis"),
  language: text("language", { enum: ["ar", "en"] }).notNull().default("ar"),
  format: text("format", { enum: ["pdf", "html", "json"] }).notNull().default("pdf"),
  content: jsonb("content"),
  filePath: text("file_path"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
});

export const insertReportSchema = createInsertSchema(reportsTable).omit({ id: true, createdAt: true });
export type InsertReport = z.infer<typeof insertReportSchema>;
export type Report = typeof reportsTable.$inferSelect;
